import React, { useCallback, useContext, useEffect, useState } from "react";
import { DContext } from "../../../context/Datacontext";
import { Pagination } from "../../../utils/Pagination";

export const OrderCourses = () => {

    const { BeURL } = useContext(DContext);

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedOrder, setSelectedOrder] = useState(null);

    const [page, setPage] = useState(() =>
        Number(localStorage.getItem("coursePage")) || 1
    );

    const [limit, setLimit] = useState(() =>
        Number(localStorage.getItem("courseLimit")) || 10
    );

    const [totalCourses, setTotalCourses] = useState(0);

    console.log("courses" , courses)

    // Save pagination
    useEffect(() => {
        localStorage.setItem("coursePage", page);
        localStorage.setItem("courseLimit", limit);
    }, [page, limit]);

    const fetchInstructorCourses = useCallback(
        async (p = page, l = limit) => {

            try {

                setLoading(true);

                const params = new URLSearchParams();
                params.set("page", p);
                params.set("limit", l);

                const res = await fetch(
                    `${BeURL}/order-courses-to-ins?${params.toString()}`,
                    { credentials: "include" }
                );

                const data = await res.json();

                if (data.success) {
                    setCourses(data.orders || []);
                    setTotalCourses(data.total || 0);
                } else {
                    setCourses([]);
                    setTotalCourses(0);
                }

            } catch (err) {

                console.error(err);

            } finally {

                setLoading(false);

            }

        },
        [BeURL, page, limit]
    );

    useEffect(() => {
        fetchInstructorCourses(page, limit);
    }, [page, limit, fetchInstructorCourses]);

    const safe = (val) => {
        if (val === null || val === undefined) return "-";
        if (typeof val === "string" || typeof val === "number") return val;
        if (typeof val === "object") return JSON.stringify(val);
        return "-";
    };

    const totalPages = Math.max(1, Math.ceil(totalCourses / limit));

    if (loading) return <div className="p-6">Loading...</div>;

    return (
        <div className="p-6 space-y-6 min-h-screen">

            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold">Orders</h2>
            </div>

            {totalCourses === 0 ? (
                <p>No Orders Found</p>
            ) : (

                <div className="bg-white rounded-xl shadow overflow-hidden">
                    <table className="min-w-full text-sm">
                        <thead className="bg-primary-100 text-primary-600">
                            <tr>
                                <th className="px-4 py-3 text-left">Sl.No</th>
                                <th className="px-4 py-3 text-left">Order Id</th>
                                <th className="px-4 py-3 text-left">Title</th>
                                <th className="px-4 py-3 text-left">Price</th>
                                <th className="px-4 py-3 text-left">Date</th>
                                <th className="px-4 py-3 text-left">Status</th>
                                <th className="px-4 py-3 text-left">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {courses.map((course, idx) => {
                                return (
                                    <tr
                                        key={course._id}
                                        className="border-t hover:bg-gray-50"
                                    >
                                        <td className="px-4 py-3">
                                            {(page - 1) * limit + idx + 1}
                                        </td>
                                        <td className="px-4 py-3">
                                            {safe(course?.orderId)}
                                        </td>
                                        <td className="px-4 py-3 font-medium">
                                            {safe(course?.course?.title)}
                                        </td>
                                        <td className="px-4 py-3">
                                            ₹{safe(course?.pricing?.totalAmount)}
                                        </td>
                                        <td className="px-4 py-3">
                                            {safe(course?.createdAt)}
                                        </td>
                                        <td className="px-4 py-3">
                                            {safe(course?.orderStatus)}
                                        </td>
                                        <td className="px-4 py-3">
                                            <button
                                                onClick={() => setSelectedOrder(course)}
                                                className="text-blue-600 font-medium hover:underline"
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <div className="border-t">
                        <Pagination
                            page={page}
                            totalPages={totalPages}
                            limit={limit}
                            totalUsers={totalCourses}
                            setPage={setPage}
                            setLimit={(newLimit) => {
                                const firstIndex = (page - 1) * limit;
                                const newPage = Math.floor(firstIndex / newLimit) + 1;
                                setLimit(newLimit);
                                setPage(newPage);
                            }}
                        />
                    </div>
                </div>
            )}

            {/* Modal */}
            {selectedOrder && (
                <div className="fixed inset-0 bg-secondary-100/40 backdrop-blur-sm flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-xl w-[650px] overflow-hidden relative">
                        {/* Close Button */}
                        <button
                            onClick={() => setSelectedOrder(null)}
                            className="absolute right-4 top-4 text-gray-600 hover:text-black text-xl"
                        >
                            ✕
                        </button>

                        {/* Header */}
                        <div className="p-6 border-b">
                            <h3 className="text-xl font-bold">Order Details</h3>
                        </div>

                        <div className="p-6 space-y-6">
                            {/* Course Info */}
                            <div className="flex gap-4">
                                <img
                                    src={`${BeURL}${selectedOrder?.course?.thumbnail}`}
                                    alt="course"
                                    className="w-32 h-20 object-cover rounded-lg border"
                                />
                                <div>
                                    <h4 className="font-semibold text-lg">
                                        {safe(selectedOrder?.course?.title)}
                                    </h4>
                                    <p className="text-gray-500 text-sm">
                                        Course ID : {safe(selectedOrder?.course?.id)}
                                    </p>
                                    <p className="text-green-600 font-semibold mt-1">
                                        ₹{safe(selectedOrder?.pricing?.totalAmount)}
                                    </p>
                                </div>
                            </div>

                            {/* Student Details */}
                            <div className="border-t pt-4">
                                <h4 className="font-semibold mb-2 text-gray-700">
                                    Student Details
                                </h4>
                                <div className="grid grid-cols-2 gap-3 text-sm">
                                    <p>
                                        <b>Name :</b> {safe(selectedOrder?.fullName)}
                                    </p>
                                    <p>
                                        <b>Email :</b> {safe(selectedOrder?.email)}
                                    </p>
                                    <p>
                                        <b>Phone :</b> {safe(selectedOrder?.contact)}
                                    </p>
                                    <p>
                                        <b>Order ID :</b> {safe(selectedOrder?.orderId)}
                                    </p>
                                </div>
                            </div>

                            {/* Payment Details */}
                            <div className="border-t pt-4">
                                <h4 className="font-semibold mb-2 text-gray-700">
                                    Payment Details
                                </h4>
                                <div className="grid grid-cols-2 gap-3 text-sm">
                                    <p>
                                        <b>Subtotal :</b> ₹{safe(selectedOrder?.pricing?.subtotal)}
                                    </p>
                                    <p>
                                        <b>Discount :</b> ₹{safe(selectedOrder?.pricing?.discount)}
                                    </p>
                                    <p>
                                        <b>Total :</b> ₹{safe(selectedOrder?.pricing?.totalAmount)}
                                    </p>
                                    {console.log("payment" , selectedOrder)}
                                    <p>
                                        <b>Status :</b>
                                        <span className={`ml-2 px-2 py-1 rounded-full text-xs font-semibold
                                       ${selectedOrder?.orderStatus === "completed"
                                                ? "bg-green-100 text-green-700"
                                                : "bg-red-100 text-red-700"
                                            }`}>
                                            {safe(selectedOrder?.orderStatus)}
                                        </span>
                                    </p>
                                </div>
                            </div>

                            {/* Order Info */}
                            <div className="border-t pt-4 text-sm">
                                <p>
                                    <b>Order Status :</b> {safe(selectedOrder?.orderStatus)}
                                </p>
                                <p>
                                    <b>Created At :</b> {safe(selectedOrder?.createdAt)}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};